import { GL300_REGEX, GL500_REGEX, SIMULATED_GL_REGEX, XIRGO_REGEX } from 'src/services/constants.js';
import store from 'src/store';

/**
 * Logs an event (with optional metadata) to Intercom.
 *
 * @param {String} name
 * @param {Object} metaData
 */
export function trackEvent(name, metaData) {
  const { id: accountId } = store().getters['session/account'];
  const { churnzeroAppKey: churnZeroAppKey } = store().state.env;
  const { email } = store().getters['session/currentUser'];
  let churnZeroMetaData = {};
  if (!store().getters['session/isConsumer']) {
    churnZeroMetaData = {
      account_external_id: accountId,
      app_key: churnZeroAppKey,
      contact_external_id: email,
    };
  }
  return window.Intercom && window.Intercom('trackEvent', name, { ...churnZeroMetaData, ...metaData });
}

/**
 * Updates user data in Intercom.
 *
 * @param {Object} data
 */
export function update(data) {
  return window.Intercom && window.Intercom('update', data);
}

/**
 * Generates counts of various types of devices in the account and updates Intercom
 *
 * @param {Object} data
 */
export function updateDeviceCounts({ vehicles = [], assets = [] }) {
  const vehicleDevices = new Set();
  const assetDevices = new Set();
  const counts = {
    gl300: 0,
    gl500: 0,
    queclink: 0,
    raven: 0,
    xirgo: 0,
    unknown: [],
  };
  vehicles.forEach(({ devices = [] }) => {
    devices.forEach(({ serial }) => {
      if (serial && !vehicleDevices.has(serial)) {
        vehicleDevices.add(serial);
        if (GL300_REGEX.test(serial)) {
          counts.gl300 += 1;
        } else if (GL500_REGEX.test(serial)) {
          counts.gl500 += 1;
        } else if (serial.toLowerCase().startsWith('q')) {
          counts.queclink += 1;
        } else if (serial.toLowerCase().startsWith('1rv') || serial.toLowerCase().startsWith('2rv')) {
          counts.raven += 1;
        } else if (XIRGO_REGEX.test(serial)) {
          counts.xirgo += 1;
        } else if (!SIMULATED_GL_REGEX.test(serial)) {
          counts.unknown.push(serial);
        }
      }
    });
  });
  assets.forEach(({ devices = [] }) => {
    devices.forEach(({ serial }) => {
      if (serial && !assetDevices.has(serial)) {
        assetDevices.add(serial);
      }
    });
  });
  counts.assettrak = assetDevices.size;
  const payload = {
    account_assets: assets.length,
    account_devices: vehicleDevices.size + assetDevices.size,
    account_vehicles: vehicles.length,
    asset_track_devices: assetDevices.size,
    gl300_devices: counts.gl300,
    gl500_devices: counts.gl500,
    queclink_vehicle_devices: counts.queclink,
    raven_devices: counts.raven,
    xirgo_devices: counts.xirgo,
  };
  update(payload);
}

/**
 * Logs an event (with optional metadata) to Intercom via the Contacts API.
 *
 * @param {String} name
 * @param {Object} metaData
 */
export function trackEventByApi(name, metaData) {
  const currentUser = store().getters['session/currentUser'];

  store().state.app.apiWorker.logEvent({
    data: metaData,
    event: name,
    type: 'intercom',
    userKey: currentUser.key,
  });
}
